import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';

import { ButtonBase, Typography } from 'common/components/material';

type ObjectiveFilterPillProps = {
  label: string;
  count: number;
  active: boolean;
  onClick: () => void;
};

const ObjectiveFilterPill: React.FC<ObjectiveFilterPillProps> = ({
  label,
  count,
  active,
  onClick,
}) => {
  const { palette } = useTheme();
  const activeColor = palette.SelectionChips.Primary.BgDefault;

  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1,
        py: 0.375,
        borderRadius: '999px',
        border: `1px solid ${active ? activeColor : palette.Card.Stroke}`,
        backgroundColor: active ? alpha(activeColor, 0.16) : 'transparent',
        '&:hover': { borderColor: activeColor },
      }}
    >
      <Typography
        variant="caption2"
        fontWeight={600}
        color={active ? palette.Text.Headline : palette.Text.Caption}
      >
        {label}
      </Typography>

      <Typography
        variant="caption2"
        fontWeight={700}
        color={active ? activeColor : palette.Text.SubtleText}
      >
        {count}
      </Typography>
    </ButtonBase>
  );
};

export default ObjectiveFilterPill;
